(function () {
    'use strict';

    var CART_LINK_SELECTOR = [
        '#cart-icon-bubble',
        'a.header__icon--cart',
        '.header a[href*="/cart"]',
        '.header-wrapper a[href*="/cart"]',
        'header a[href*="/cart"]',
        '[data-cart-sidebar]',
        '[data-open-cart-popup]'
    ].join(',');

    var BODY_OPEN_CLASSES = ['cart-sidebar-show', 'open-cart-sidebar', 'quick-cart-show'];
    var DRAWER_OPEN_CLASSES = ['active', 'is-show', 'show'];
    var STYLE_ID = 'header-cart-drawer-z-index-fix';

    function onReady(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    }

    function getDrawer() {
        return document.getElementById('halo-cart-sidebar') ||
            document.querySelector('.halo-cart-sidebar') ||
            document.querySelector('[data-cart-sidebar-content]');
    }

    function forEachClass(element, classNames, action) {
        if (!element) return;
        classNames.forEach(function (className) {
            element.classList[action](className);
        });
    }

    function injectZIndexFix() {
        if (document.getElementById(STYLE_ID)) return;

        var style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = [
            'body.cart-sidebar-show .shopify-section-header,',
            'body.cart-sidebar-show sticky-header,',
            'body.cart-sidebar-show .header-wrapper,',
            'body.open-cart-sidebar .shopify-section-header,',
            'body.open-cart-sidebar sticky-header,',
            'body.open-cart-sidebar .header-wrapper,',
            'body.quick-cart-show .shopify-section-header,',
            'body.quick-cart-show sticky-header,',
            'body.quick-cart-show .header-wrapper {',
            '  z-index: 1 !important;',
            '}',
            '#halo-cart-sidebar,',
            '.halo-cart-sidebar,',
            '[data-cart-sidebar-content] {',
            '  z-index: 99999 !important;',
            '}',
            'body.cart-sidebar-show .background-overlay,',
            'body.open-cart-sidebar .background-overlay,',
            'body.quick-cart-show .background-overlay {',
            '  z-index: 99998 !important;',
            '}'
        ].join('\n');
        document.head.appendChild(style);
    }

    function prepareCartLinks() {
        document.querySelectorAll(CART_LINK_SELECTOR).forEach(function (link) {
            if (!link.closest('header') && !link.closest('.header-wrapper') && !link.classList.contains('header__icon--cart') && link.id !== 'cart-icon-bubble') return;
            link.setAttribute('href', 'javascript:void(0)');
            link.setAttribute('data-cart-sidebar', '');
            link.removeAttribute('data-open-cart-popup');
            link.setAttribute('role', 'button');
        });
    }

    function ensureDrawerStyle(drawer) {
        if (!drawer) return;
        var styleUrl = drawer.getAttribute('data-url-style-cart-sidebar');
        if (!styleUrl || document.querySelector('link[href="' + styleUrl + '"]')) return;

        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = styleUrl;
        document.head.appendChild(link);
    }

    function openCartSidebar(trigger) {
        var drawer = getDrawer();
        if (!drawer) return;

        injectZIndexFix();
        ensureDrawerStyle(drawer);

        var showDrawer = function () {
            forEachClass(document.body, BODY_OPEN_CLASSES, 'add');
            forEachClass(drawer, DRAWER_OPEN_CLASSES, 'add');
            drawer.setAttribute('aria-hidden', 'false');
        };

        var quickCart = drawer.querySelector('quick-cart-items');
        if (quickCart && typeof quickCart.update === 'function') {
            fetch('/cart.js')
                .then(function (response) { return response.json(); })
                .then(function (cart) {
                    quickCart.update(cart);
                    showDrawer();
                })
                .catch(showDrawer);
        } else {
            showDrawer();
        }
    }

    function closeCartSidebar(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        }

        var drawer = getDrawer();
        forEachClass(document.body, BODY_OPEN_CLASSES, 'remove');
        forEachClass(drawer, DRAWER_OPEN_CLASSES, 'remove');
        if (drawer) drawer.setAttribute('aria-hidden', 'true');
    }

    onReady(function () {
        injectZIndexFix();
        prepareCartLinks();

        document.addEventListener('click', function (event) {
            var cartLink = event.target.closest(CART_LINK_SELECTOR);
            if (cartLink && (cartLink.closest('header') || cartLink.closest('.header-wrapper') || cartLink.classList.contains('header__icon--cart') || cartLink.id === 'cart-icon-bubble')) {
                event.preventDefault();
                event.stopPropagation();
                if (event.stopImmediatePropagation) event.stopImmediatePropagation();
                openCartSidebar(cartLink);
                return false;
            }

            if (event.target.closest('[data-close-cart-sidebar]')) {
                closeCartSidebar(event);
            }
        }, true);

        var overlay = document.querySelector('.background-overlay');
        if (overlay) overlay.addEventListener('click', closeCartSidebar, true);
    });
})();
